module.exports = __webpack_public_path__ + "static/dinosaur1-bba3222a40938d5880dab8c60f80abd4.png";